<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="surveys">
            <div class="col-md-2 hidden-xs hidden-sm">
                <l-side-menu>
                    <l-side-menu-picture :src="icon"></l-side-menu-picture>

                    <l-side-menu-element
                        v-for="item in menu"
                        :key="item.path"
                        :show="item.show"
                        :type="item.type"
                        :icon="item.icon"
                        :label="item.label"
                        :path="item.path"
                        :handler="() => goTo(item.path)"
                        :active="item.active"
                    ></l-side-menu-element>
                </l-side-menu>
            </div>

            <div v-if="$route.params.tab == 'list'" class="col-md-10">
                <l-card-content>
                    <l-headline :title="$t('surveys.list.titleAdmin')" :sub-title="``" :tabs="tabs">
                    </l-headline>
                    <div v-show="!list || !list.length" class="row">
                        <div class="col-md-6 col-md-offset-3 text-center">
                            <h4>{{ $t("surveys.list.listEmptyH1") }}</h4>
                            <br />
                            <div class="text-center">
                                <img alt="heapmap" :src="icon" width="250" />
                            </div>
                            <br />
                        </div>
                    </div>

                    <div v-show="list && list.length" class="row">
                        <div class="col-md-12">
                            <div class="form-group label-floating" style="margin-top: 5px">
                                <l-input-text
                                    v-model="searchKeyword"
                                    :label="''"
                                    :placeholder="$t(`surveys.list.searchPlaceholder`)"
                                    type="text"
                                    optional
                                    hide-help-block
                                    size="m"
                                    data-test-id="surveys-search"
                                />
                            </div>
                        </div>
                    </div>
                </l-card-content>

                <l-card-content
                    v-for="section in statusSections"
                    v-show="matchCount(section) > 0"
                    :key="section.status"
                >
                    <div
                        class="headline-small clickable"
                        style="margin-bottom: 0px"
                        :data-test-id="`survey-list-${section.status}`"
                        tabindex="0"
                        @click="
                            () => {
                                section.expanded = !section.expanded;
                                $forceUpdate();
                            }
                        "
                        @keyup.enter="
                            () => {
                                section.expanded = !section.expanded;
                                $forceUpdate();
                            }
                        "
                    >
                        <span style="text-transform: capitalize;">{{
                            $t("surveys.list.section_" + section.status)
                        }}</span>
                        ({{ matchCount(section) }})
                        <i
                            style="margin-left: 9px;"
                            class="fa"
                            :class="[section.expanded ? 'fa-caret-down' : 'fa-caret-right']"
                        ></i>
                    </div>

                    <div v-show="section.expanded">
                        <hr />
                        <div
                            v-for="(survey, id) in section.data"
                            v-show="nameSearchHit(survey)"
                            :key="id"
                        >
                            <div
                                v-show="survey.type == 'adminDraft'"
                                tabindex="0"
                                class="tw-cursor-pointer"
                                @click="() => editSurvey(survey._id)"
                                @keyup.enter="editSurvey(survey._id)"
                            >
                                <l-survey-item
                                    :data-test-class="`survey-list-${section.status}-item`"
                                    :survey="survey"
                                ></l-survey-item>
                                <hr v-show="id != section.data.length - 1" />
                            </div>

                            <div
                                v-show="survey.type != 'adminDraft'"
                                tabindex="0"
                                class="tw-cursor-pointer"
                                @click="openSurveyDetail(survey)"
                                @keyup.enter="openSurveyDetail(survey)"
                            >
                                <l-survey-item :survey="survey"></l-survey-item>
                                <hr v-show="id != section.data.length - 1" />
                            </div>
                        </div>
                    </div>
                </l-card-content>

                <l-card-content
                    v-for="section in tagSections"
                    v-show="matchCount(section) > 0"
                    :key="section.name"
                >
                    <div
                        class="headline-small clickable"
                        style="margin-bottom: 0px"
                        tabindex="0"
                        @click="
                            () => {
                                section.expanded = !section.expanded;
                                $forceUpdate();
                            }
                        "
                        @keyup.enter="
                            () => {
                                section.expanded = !section.expanded;
                                $forceUpdate();
                            }
                        "
                    >
                        <span style="text-transform: capitalize;">#{{ section.name }}</span> ({{
                            matchCount(section)
                        }})
                        <i
                            class="fa"
                            :class="[section.expanded ? 'fa-caret-down' : 'fa-caret-right']"
                        ></i>
                    </div>

                    <div v-show="section.expanded">
                        <hr />
                        <div
                            v-for="(survey, id) in section.data"
                            v-show="nameSearchHit(survey)"
                            :key="id"
                        >
                            <div
                                v-show="survey.type == 'adminDraft'"
                                tabindex="0"
                                class="tw-cursor-pointer"
                                @click="() => editSurvey(survey._id)"
                                @keyup.enter="editSurvey(survey._id)"
                            >
                                <l-survey-item :survey="survey"></l-survey-item>
                                <hr v-show="id != section.data.length - 1" />
                            </div>

                            <div
                                v-show="survey.type != 'adminDraft'"
                                tabindex="0"
                                class="tw-cursor-pointer"
                                @click="openSurveyDetail(survey)"
                                @keyup.enter="openSurveyDetail(survey)"
                            >
                                <l-survey-item :survey="survey"></l-survey-item>
                                <hr v-show="id != section.data.length - 1" />
                            </div>
                        </div>
                    </div>
                </l-card-content>
            </div>

            <div v-if="$route.params.tab == 'open'" class="col-md-10">
                <l-card-content>
                    <l-headline
                        :title="$t('surveys.open.title')"
                        :sub-title="$t('surveys.open.subTitle')"
                        :tabs="tabs"
                    />

                    <l-notifications-list
                        :notifications="notifications"
                        :is-visitor="false"
                        :max-amount-visible-default="6"
                        :show-notification-creation-time="false"
                    />
                </l-card-content>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSideMenu from "@/components/LSideMenu";
import LSideMenuPicture from "@/components/LSideMenuPicture";

import LCardContent from "@/components/LCardContent";
import LSideMenuElement from "@/components/LSideMenuElement";
import LHeadline from "@/components/LHeadline";
import LInputText from "@/components/LInputText";
import LSurveyItem from "@/components/LSurveyItem";
import LNotificationsList from "@/components/LUserProfile/LNotificationsList";

import icon from "@/img/icons/surveys.png";

export default {
    components: {
        LCardContent,
        LSideMenu,
        LSideMenuPicture,
        LSideMenuElement,
        LHeadline,
        LInputText,
        LSurveyItem,
        LNotificationsList,
    },
    props: {},
    data() {
        return {
            searchKeyword: "",

            error: false,
        };
    },
    computed: {
        ...mapGetters({
            teamSettings: "users/current/teamSettings",
            rights: "users/current/rights",
            user: "users/current/user",
            list: "surveys/surveys/list",
            result: "surveys/surveys/result",
            tags: "tags/tags/surveys",
            notifications: "notifications/profilePreview/notifications",
        }),
        menu() {
            return [
                {
                    show: this.notifications.length > 0,
                    active: this.$route.params.tab === "open",
                    icon: "fal fa-poll icon-light",
                    label: this.$t("surveys.open.menu"),
                    path: "/surveys/open",
                },
                {
                    show: true,
                    active: this.$route.params.tab == "list",
                    icon: "fal fa-cog icon-light",
                    label: this.$t("surveys.list.menuAdmin"),
                    path: "/surveys/list",
                },
            ];
        },
        useMeridianTime() {
            return this.teamSettings.useMeridianTime;
        },
        tabs() {
            return [
                {
                    label: this.$t(`surveys.list.subtitleAdmin`),
                    show: this.$route.params.tab == "list",
                    tabClass: "descriptive",
                    active: false,
                },
                {
                    tabClass: "space",
                    show: true,
                },
                {
                    label: this.$t(`surveys.list.btnCreate`),
                    show: this.$route.params.tab == "list" && this.rights.S_CREATE,
                    handler: this.create,
                    isButton: true,
                    tabClass: "btn-primary",
                },
            ];
        },
    },
    watch: {
        "$route.params.tab": {
            immediate: true,
            handler() {
                // Move to list view if there are no open surveys which require
                // a user contribution
                if (this.$route.params.tab === "open" && !this.notifications?.length) {
                    this.$router.replace({ params: { tab: "list" } });
                }
            },
        },
    },
    created() {
        this.icon = icon;

        const statusSections = [
            { status: "active", expanded: true, data: [] },
            { status: "draft", data: [] },
            { status: "paused", data: [] },
            { status: "closed", data: [] },
        ];
        statusSections.forEach((section, index) => {
            statusSections[index].data = this.list
                .filter(s => s.status == section.status)
                .sort((a, b) => a.timing.nextPeriodStart - b.timing.nextPeriodStart);
        });
        const tagSections = this.tags.map(tag => ({
            name: tag.name,
            expanded: false,
        }));

        tagSections.forEach((tag, index) => {
            tagSections[index].data = this.list
                .filter(function(s) {
                    return (s.tags || []).find(t => {
                        return t.name == tag.name;
                    });
                })
                .sort((a, b) => a.timing.nextPeriodStart - b.timing.nextPeriodStart);
        });

        this.statusSections = statusSections;
        this.tagSections = tagSections;
    },
    methods: {
        matchCount(section) {
            let count = 0;
            section.data.forEach(survey => {
                if (this.nameSearchHit(survey)) {
                    count += 1;
                }
            });
            return count;
        },
        nameSearchHit(survey) {
            if (!survey || !survey.name) {
                return false;
            }
            return survey.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) !== -1;
        },
        create() {
            this.$router.push(`/surveys/edit/new`);
        },
        openSurveyDetail(survey) {
            if (survey.sharedWith?.scope?.includes("LIST")) {
                // only redirect to list if accessible
                this.$router.push(`/surveys/insights/${survey._id}/list`);
            } else {
                // can always be accessed (at least own comments)
                this.$router.push(`/surveys/insights/${survey._id}/comments`);
            }
        },
        editSurvey(id) {
            this.$router.push(`/surveys/edit/${id}`);
        },
        goTo(url) {
            this.$router.push(url);
        },
    },
};
</script>

<style scoped>
.users-with-meetings-info {
    display: flex;
    height: 40px;
}
.stats-visibility {
    cursor: help;
}
.stats-meeting-user-picture {
    margin-right: -10px;
}
</style>
